import { render, staticRenderFns } from "./BillManagePage.vue?vue&type=template&id=61389f32&"
import script from "./BillManagePage.vue?vue&type=script&lang=js&"
export * from "./BillManagePage.vue?vue&type=script&lang=js&"
import style0 from "./BillManagePage.vue?vue&type=style&index=0&id=61389f32&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports